import { render } from "./ViewNotification.vue?vue&type=template&id=b4ad39c6&ts=true"
import script from "./ViewNotification.vue?vue&type=script&lang=ts"
export * from "./ViewNotification.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__